import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-508e0f16")
const _hoisted_1 = { class: "number" }
const _hoisted_2 = ["disabled", "max", "min", "step"]
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("input", {
      disabled: _ctx.disabled,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.value = $event)),
      max: _ctx.max,
      min: _ctx.min,
      step: _ctx.step,
      type: "number"
    }, null, 8, _hoisted_2), [
      [_vModelText, _ctx.value]
    ])
  ]))
}